module.exports = __webpack_public_path__ + "img/caba_general.0f415200.svg";